var _path, _path2, _path3, _path4, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgGooglePay(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")"),
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.227c0-.709-.065-1.39-.186-2.045h-9.61v3.868h5.492c-.237 1.25-.956 2.31-2.036 3.018v2.51h3.297c1.93-1.742 3.043-4.305 3.043-7.35z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.204 20c2.755 0 5.065-.895 6.753-2.423l-3.298-2.509c-.913.6-2.082.955-3.455.955-2.658 0-4.907-1.76-5.71-4.123H1.085v2.59c1.68 3.27 5.13 5.51 9.12 5.51z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.494 11.9c-.204-.6-.32-1.24-.32-1.9 0-.66.116-1.3.32-1.9V5.51H1.085a9.834 9.834 0 000 8.98l3.41-2.59z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.204 3.977c1.498 0 2.843.505 3.9 1.496l2.928-2.868C15.264.99 12.954 0 10.204 0c-3.989 0-7.44 2.24-9.119 5.51l3.41 2.59c.802-2.364 3.051-4.123 5.71-4.123z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#fff"
  })))));
}
export default SvgGooglePay;